module.exports = __webpack_public_path__ + "img/toose-taavon.41e3e7db.png";